var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center" },
        [
          _vm.loading
            ? _c("b-spinner", { staticClass: "mx-2", attrs: { large: "" } })
            : _vm._e(),
          _vm.loading ? _c("span", [_vm._v("Loading...")]) : _vm._e(),
        ],
        1
      ),
      _vm._v(". "),
      !_vm.loading
        ? _c(
            "b-card",
            [
              _c("validation-observer", {
                ref: "editRawMaterialValidation",
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var invalid = ref.invalid
                        return [
                          !_vm.loading
                            ? _c(
                                "b-form",
                                {
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.editRawMaterial($event)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "d-flex justify-content-end",
                                          attrs: { md: "12" },
                                        },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              staticStyle: {
                                                "margin-top": "20px",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleDocumentBtn(
                                                        _vm.rawmaterialsID.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Documents")]
                                              ),
                                              _vm.loading
                                                ? _c("b-spinner", {
                                                    staticClass: "mt-1",
                                                    staticStyle: {
                                                      width: "3rem",
                                                      height: "3rem",
                                                      "margin-left": "32px",
                                                    },
                                                    attrs: {
                                                      variant: "success",
                                                      label: "Spinning",
                                                      block: "",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-modal",
                                            {
                                              ref: "modal-view-raw-material-document",
                                              attrs: {
                                                id: "modal-view-raw-material-document",
                                                "ok-only": "",
                                                "ok-title": "View",
                                                centered: "",
                                                size: "lg",
                                                title:
                                                  "View Raw Material Documents",
                                                "hide-footer": true,
                                              },
                                            },
                                            [
                                              _c("DocumentUpload", {
                                                attrs: {
                                                  documentDetails:
                                                    _vm.documentDetails,
                                                },
                                                on: {
                                                  deleteFile: _vm.deleteFile,
                                                  downloadFile:
                                                    _vm.downloadFile,
                                                  uploadFiles: _vm.uploadFiles,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                "label-for":
                                                  "mc-Raw Material-Supplier",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function () {
                                                      return [
                                                        _vm._v(
                                                          " Raw Material Name "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [_vm._v("(*)")]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  name: "Raw Material Name",
                                                  rules: "required",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: "mc-Raw Material-Supplier",
                                                              placeholder:
                                                                "Raw Material",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .rawmaterialsID
                                                                  .name,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.rawmaterialsID,
                                                                    "name",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "rawmaterialsID.name",
                                                            },
                                                          }),
                                                          errors.length
                                                            ? _c(
                                                                "small",
                                                                {
                                                                  staticClass:
                                                                    "text-danger",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Raw Material Code",
                                                "label-for":
                                                  "mc-Raw Material-Code",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "mc-Raw Material-Code",
                                                },
                                                model: {
                                                  value:
                                                    _vm.rawmaterialsID.code,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.rawmaterialsID,
                                                      "code",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "rawmaterialsID.code",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                "label-for":
                                                  "mc-stock-threshold",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function () {
                                                      return [
                                                        _vm._v(
                                                          " Low Stock Threshold "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [_vm._v("(*)")]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  name: "Low Stock Threshold",
                                                  vid: "code",
                                                  rules: "required",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-label-group",
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id: "mc-stock",
                                                                    type: "text",
                                                                    placeholder:
                                                                      "Low Stock Threshold",
                                                                  },
                                                                  on: {
                                                                    keypress:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.allowOnlyNumbers(
                                                                          $event
                                                                        )
                                                                      },
                                                                    wheel:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.allowOnlyNumbers(
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .rawmaterialsID
                                                                        .lowStock,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.rawmaterialsID,
                                                                          "lowStock",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "rawmaterialsID.lowStock",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          errors.length
                                                            ? _c(
                                                                "small",
                                                                {
                                                                  staticClass:
                                                                    "text-danger",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                "label-for": "mc-Category",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function () {
                                                      return [
                                                        _vm._v(" Category "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [_vm._v("(*)")]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  name: "Category",
                                                  rules: "required",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-select", {
                                                            attrs: {
                                                              options:
                                                                _vm.parentCategoryList,
                                                              "value-field":
                                                                "id",
                                                              "text-field":
                                                                "name",
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.setSubCategory,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .rawmaterialsID
                                                                  .categoryID,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.rawmaterialsID,
                                                                    "categoryID",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "rawmaterialsID.categoryID",
                                                            },
                                                          }),
                                                          errors.length
                                                            ? _c(
                                                                "small",
                                                                {
                                                                  staticClass:
                                                                    "text-danger",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.rawmaterialsID
                                                    .categoryID != null,
                                                label: "Sub Category",
                                                "label-for": "mc-subCategory",
                                              },
                                            },
                                            [
                                              _c("b-form-select", {
                                                attrs: {
                                                  options: _vm.subCategoryList,
                                                  "value-field": "id",
                                                  "text-field": "name",
                                                },
                                                model: {
                                                  value:
                                                    _vm.rawmaterialsID
                                                      .productCategorySubId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.rawmaterialsID,
                                                      "productCategorySubId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "rawmaterialsID.productCategorySubId",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "UOM",
                                                "label-for": "mc-Uom",
                                              },
                                            },
                                            [
                                              _c("b-form-select", {
                                                attrs: {
                                                  options: _vm.itemUomList,
                                                  "value-field": "id",
                                                  "text-field": "name",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.newuom(
                                                      _vm.uomName
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.uomName,
                                                  callback: function ($$v) {
                                                    _vm.uomName = $$v
                                                  },
                                                  expression: "uomName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Price (Rs)",
                                                "label-for": "Price (Rs)",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "number",
                                                  id: "mc-Raw Material-Price",
                                                  placeholder:
                                                    "Raw Material Price",
                                                },
                                                on: {
                                                  keypress: function ($event) {
                                                    return _vm.allowOnlyNumbers(
                                                      $event
                                                    )
                                                  },
                                                  wheel: function ($event) {
                                                    return _vm.allowOnlyNumbers(
                                                      $event
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.rawmaterialsID
                                                      .purchasePrice,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.rawmaterialsID,
                                                      "purchasePrice",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "rawmaterialsID.purchasePrice",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Preferred Supplier",
                                                "label-for": "mc-Supplier",
                                              },
                                            },
                                            [
                                              _c("b-form-select", {
                                                attrs: {
                                                  options: _vm.supplierOptions,
                                                  "value-field": "id",
                                                  "text-field": "name",
                                                },
                                                model: {
                                                  value:
                                                    _vm.rawmaterialsID
                                                      .supplierId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.rawmaterialsID,
                                                      "supplierId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "rawmaterialsID.supplierId",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mb-2",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for: "textarea-default",
                                              },
                                            },
                                            [_vm._v("Raw Material Description")]
                                          ),
                                          _c("b-form-textarea", {
                                            attrs: {
                                              id: "textarea-default",
                                              rows: "5",
                                              required: "",
                                              placeholder: "Description",
                                            },
                                            model: {
                                              value:
                                                _vm.rawmaterialsID.description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.rawmaterialsID,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "rawmaterialsID.description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("CustomFieldsDetails", {
                                            attrs: {
                                              AdditionalFields:
                                                _vm.rawmaterialsID
                                                  .additionalFields,
                                              ModuleReference: "RawMaterial",
                                            },
                                            on: {
                                              onchange:
                                                _vm.additionalFieldChanges,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-row",
                                        { staticClass: "p-1" },
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass:
                                                "d-flex justify-content-end",
                                              attrs: { md: "12" },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    type: "submit",
                                                    variant: "primary",
                                                  },
                                                  on: {
                                                    click: _vm.editRawMaterial,
                                                  },
                                                },
                                                [_vm._v("Submit")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2437429827
                ),
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }